import type { ReactNode } from 'react';
import { toast } from 'react-toastify';

export type AppToastOptions = Record<string, unknown> & {
  type?: 'info' | 'success' | 'warning' | 'error' | 'default';
  autoClose?: number | false;
  hideProgressBar?: boolean;
};

export function appToast(content: ReactNode, options?: AppToastOptions) {
  if (options?.type !== 'info') {
    return toast(content, options);
  }

  const autoClose = options.autoClose ?? 7000;
  const hideProgressBar = options.hideProgressBar ?? false;

  return toast(content, { ...options, autoClose, hideProgressBar });
}
